import HttpClient from '@/services/HttpClient';
import { packageOfferSelection } from '@/modules/agreements/packageOfferSelection';

export default class AgreementViewerService {
	constructor(podUrl, token, secretKey) {
		this.token = token;
		this.podUrl = podUrl;
		this.secretKey = secretKey;
		this.httpClient = new HttpClient(podUrl, false);
	}

	getAgreement() {
		return this.httpClient
			.get(`/api/docs/agreement`, {
				headers: { Accept: 'application/json' },
				params: {
					token: this.token,
					secretKey: this.secretKey,
				},
			})
			.then((res) => Promise.resolve(res))
			.catch((err) => Promise.reject(err));
	}

	downloadPdf() {
		return this.httpClient.get(`/api/docs/agreement/pdf`, {
			responseType: 'blob',
			params: {
				token: this.token,
				secretKey: this.secretKey,
			},
		});
	}

	updatePaymentIntent(amount) {
		return this.httpClient
			.get(`/api/docs/agreement/paymentIntent`, {
				params: {
					token: this.token,
					amount: amount,
				},
			})
			.then((res) => Promise.resolve(res))
			.catch((err) => Promise.reject(err));
	}

	quotePackageOffer(selection) {
		return this.httpClient.post('/api/docs/agreement/package-offer/quote', packageOfferSelection(selection), {
			params: {
				token: this.token,
				secretKey: this.secretKey,
			},
		});
	}

	finalizeAgreement(agreement) {
		return this.httpClient
			.post(`/api/docs/agreement`, agreement, {
				params: {
					token: this.token,
				},
			})
			.then((res) => Promise.resolve(res))
			.catch((err) => Promise.reject(err));
	}


	finalizeAgreementFormData(agreement, packageOffer = null){
		let formData = new FormData();
		formData.append('agreement', JSON.stringify(agreement));
		formData.append('token', this.token);
		if (packageOffer) formData.append('packageOffer', JSON.stringify(packageOffer));

		if(agreement.fileUploads) {
			let fileUploads = agreement.fileUploads;
			fileUploads.forEach((a) => {
				formData.append('files', a);
			});
			delete agreement.fileUploads;
		}

		return this.httpClient
			.post(`/api/docs/agreement/form-data`, formData, {
				headers: {
					'Content-Type': 'multipart/form-data',
				},
			})
			.then((res) => Promise.resolve(res))
			.catch((err) => Promise.reject(err));
	}
}
